import { haptic } from '../utils/haptic';
import type { ReactNode } from 'react';
import './BadgePopup.css';

interface BadgePopupProps {
  emoji: string;
  name: string;
  onClose: () => void;
  /** When provided, shown instead of emoji */
  icon?: ReactNode;
  badgeId?: string;
}

export function BadgePopup({ emoji, name, onClose, icon }: BadgePopupProps) {
  return (
    <div className="badge-popup-overlay" onClick={onClose}>
      <div className="badge-popup" onClick={(e) => e.stopPropagation()}>
        <div className="badge-popup-emoji">
          {icon ?? emoji}
        </div>
        <div className="badge-popup-title">Новый бейдж!</div>
        <div className="badge-popup-name">{name}</div>
        <button
          className="badge-popup-btn"
          onClick={() => {
            haptic.tap();
            onClose();
          }}
        >
          Круто!
        </button>
      </div>
    </div>
  );
}
